import React from "react";
import { motion } from "framer-motion";
import SectionHeader from "../components/SectionHeader";

const techs = [
  { icon: "☁️", name: "AWS", bg: "rgba(255,153,0,.12)" },
  { icon: "🔷", name: "Azure", bg: "rgba(0,120,212,.12)" },
  { icon: "🌐", name: "Google Cloud", bg: "rgba(66,133,244,.12)" },
  { icon: "⚙️", name: "Java / Spring Boot", bg: "rgba(232,77,6,.12)" },
  { icon: "🐍", name: "Python", bg: "rgba(53,169,220,.12)" },
  { icon: "⚛️", name: "React", bg: "rgba(97,219,251,.12)" },
  { icon: "🔧", name: "Terraform", bg: "rgba(100,78,182,.12)" },
  { icon: "🐳", name: "Docker & Kubernetes", bg: "rgba(22,145,207,.12)" },
  { icon: "🔥", name: "Apache Spark", bg: "rgba(232,77,6,.12)" },
  { icon: "🏗️", name: "Databricks", bg: "rgba(255,87,34,.12)" },
  { icon: "🧠", name: "TensorFlow", bg: "rgba(255,168,0,.12)" },
  { icon: "📊", name: "Snowflake", bg: "rgba(27,163,156,.12)" },
  { icon: "🐙", name: "GitHub Actions", bg: "rgba(51,51,51,.3)" },
  { icon: "📨", name: "Apache Kafka", bg: "rgba(255,102,0,.12)" },
  { icon: "🔄", name: "Airflow", bg: "rgba(0,128,0,.12)" },
  { icon: "🧱", name: "dbt", bg: "rgba(150,0,0,.12)" },
];

const TechStack = () => {
  return (
    <section
      id="stack"
      className="section-padding"
      style={{ background: "var(--navy)" }}
      aria-labelledby="stack-title"
    >
      <div className="max-w-[1200px] mx-auto">
        <SectionHeader
          tag="Technologies"
          title="Our Technology Stack"
          subtitle="Cutting-edge technologies that power enterprise-scale solutions across cloud infrastructure, data platforms, AI/ML, and modern application development."
        />

        <div
          className="flex flex-wrap gap-4 mt-12 justify-center"
          role="list"
          aria-label="Technology stack"
        >
          {techs.map((tech, i) => (
            <motion.div
              key={tech.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.04 }}
              whileHover={{ y: -3, borderColor: "rgba(45,125,255,.4)" }}
              role="listitem"
              className="flex items-center gap-3 rounded-xl px-5 py-3 cursor-default transition-all duration-250"
              style={{
                background: "rgba(15,31,61,.7)",
                border: "1px solid rgba(45,125,255,.15)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "rgba(26,107,255,.08)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "rgba(15,31,61,.7)";
              }}
            >
              <div
                className="w-8 h-8 rounded-md flex items-center justify-center text-base flex-shrink-0"
                style={{ background: tech.bg }}
                aria-hidden="true"
              >
                {tech.icon}
              </div>
              <span className="text-sm font-medium" style={{ color: "var(--steel)" }}>
                {tech.name}
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechStack;
